import type { Bindings, Magics } from 'alpinejs'

import { $slider, type WithSlider } from '../SliderCTX'

export const sliderItem = (): ThisType<WithSlider & Magics<SliderItem>> &
  Bindings<SliderItem> => ({
  'x-intersect.threshold.60'() {
    const slider = this[$slider]
    slider.handleIntersect(this.$el)
  },
  'x-init'() {
    const slider = this[$slider]
    slider.onLoad(this.$el)
  },
  'x-on:load'() {
    const slider = this[$slider]
    slider.onLoad(this.$el)
  },
})

export type SliderItem = {
  'x-intersect.threshold.60'(): void
  'x-init'(): void
  'x-on:load'(): void
}
